import React from "react";
import { motion } from "framer-motion";

const STEPS = [
  {
    n: "01",
    title: "Arrive at the loom",
    body:
      "Four pastel balls of yarn feed threads into a slow-moving tapestry. Hover any ball to see what it carries. Nothing is required of you yet.",
  },
  {
    n: "02",
    title: "Pull the loose thread",
    body:
      "When you're ready, tap or click the tassel — or press Enter on the focused grip. Fingers reach in. The weave gives a little.",
  },
  {
    n: "03",
    title: "Take it with you",
    body:
      "An affirmation, a tip, a quote, or a 'what if' for the week. Pin the ones that land to your loomboard. The threads renew tomorrow.",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      className="relative py-24 md:py-32 bg-white/40"
      data-testid="how-it-works"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-14">
          <p className="text-xs uppercase tracking-[0.22em] text-weave-teal font-medium mb-4">
            How the loom works
          </p>
          <h2 className="text-3xl md:text-5xl font-semibold tracking-tight text-[#1a1a1a] leading-[1.1]">
            A small ritual, on purpose.
          </h2>
          <p className="mt-5 text-base md:text-lg text-[#3a3a3a]/85 leading-relaxed">
            The loom is built to be felt, not figured out. Three steps, no
            account, no timer.
          </p>
        </div>

        <ol className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-10">
          {STEPS.map((s, i) => (
            <motion.li
              key={s.n}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.1, ease: "easeOut" }}
              className="relative pl-0 md:pl-0"
              data-testid={`how-step-${i + 1}`}
            >
              <div className="flex items-baseline gap-4 mb-3">
                <span
                  className="text-4xl md:text-5xl font-light text-weave-teal/80"
                  style={{ fontFamily: "Rubik, sans-serif" }}
                >
                  {s.n}
                </span>
                <h3 className="text-xl md:text-2xl font-medium text-[#1a1a1a]">
                  {s.title}
                </h3>
              </div>
              <p className="text-base text-[#3a3a3a]/85 leading-relaxed">
                {s.body}
              </p>
            </motion.li>
          ))}
        </ol>
      </div>
    </section>
  );
}
